import {useLogin, useRegistration} from '@web-auth/webauthn-helper';
import * as $ from 'jquery';

export function markDeviceAsWebAuthnRemembered(username) {
    let expirationDate = new Date();
    expirationDate.setTime((new Date()).getTime() + (2*365*24*60*60*1000)); // two years from now
    return !! (document.cookie = `__webauthn_remember_device=${username}; expires=${expirationDate.toUTCString()}; path=/;`);
}

export function getWebAuthnRememberedUsername() {
    let cookie = document.cookie
        .split(';')
        .filter((cookie) => cookie.match(/^\s?__webauthn_remember_device=/))
        .pop();

    return cookie ? cookie.split('=').pop() : false;
}

function beforeSubmitVerifications() {
    let forms = new Set();
    $('[data-webauthn-verify-before-submit]').each(function() {
        let form = this.form;
        if (form && !forms.has(form)) {
            forms.add(form);
            $(form).submit((e) => {
                let selectInputName = $(this).attr('name').replace(/\[[^\[]+\]$/, '[select]');
                let backendCheckInputName = $(this).attr('name').replace(/\[[^\[]+\]$/, '[_webauthn_verification_required]');
                let backendCheckInput = $(`[name="${backendCheckInputName}"]`);
                let couponInput = $('[name="checkout[coupon][code]"]');
                if ($(this).is(':checked') &&
                    $(form).find(`[name="${selectInputName}"]`).is(':checked') &&
                    backendCheckInput.length &&
                    backendCheckInput.data('webauthn-verify-options') &&
                    getWebAuthnRememberedUsername() &&
                    (!couponInput.length || !couponInput.val())
                ) {
                    e.preventDefault();
                    backendCheckInput.val(1);
                    login(
                        {
                            username: getWebAuthnRememberedUsername()
                        },
                        (response) => {
                            form.submit();
                        },
                        (response) => {
                            form.submit();
                        }
                    )(backendCheckInput.data('webauthn-verify-options'));
                }
            });
        }
    });
}

export function webAuthnSupported() {
    return 'credentials' in navigator;
}

export function register(parameters, onThen, onCatch) {
    return function(options) {
        useRegistration(options)(parameters)
            .then(onThen)
            .catch(onCatch);
    };
}

export function login(parameters, onThen, onCatch) {
    return function(options) {
        useLogin(options)(parameters)
            .then(onThen)
            .catch(onCatch);
    };
}

export function onLoad() {
    if (webAuthnSupported()) {
        beforeSubmitVerifications();
        $('.js-webauthn-supported').toggleClass('hidden');
        let addDeviceButton = $('.js-webauthn-add-device');
        if (addDeviceButton.length && getWebAuthnRememberedUsername()) {
            addDeviceButton.hasClass('hidden') || addDeviceButton.addClass('hidden');
        }
    } else {
        $('.js-webauthn-not-supported').toggleClass('hidden');
    }
    let registerParametersElement = $('[data-webauthn-register-paramaters]');
    if (registerParametersElement.length && webAuthnSupported()) {
        registerParametersElement.on('click', () => {
            let parameters = registerParametersElement.data('webauthn-register-paramaters');
            let options = registerParametersElement.data('webauthn-register-options');
            register(
                parameters,
                function(response) {
                    console.log(response);
                    if (response.location) {
                        markDeviceAsWebAuthnRemembered(parameters.username) || console.log('Could not mark device as WebAuthn Remembered');
                        window.location = response.location;
                    }
                },
                function(response) {
                    console.log(response)
                }
            )(options);
        });
    }
}
